import React, { ChangeEvent } from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import DocTemplateList from 'src/models/common/DocTemplateList';

interface IGenerateDocListProps {
    key?: string;
    customDoc: DocTemplateList;
    disabled: boolean;
    setTemplateId: (id: number) => void;
    renderDocTemplate: () => void;
}

const DocGenerationComponent = (props: IGenerateDocListProps) => {

    const displayTemplateList = () => {
        return (
            <RHFSelect
                name={props.customDoc.name}
                label={`${props.customDoc.name}`}
                style={{ width: '150px' }}
                options={props.customDoc.templates.map((t) => {
                    return { value: t.id, label: t.name };
                })}
                onChange={(e: ChangeEvent<HTMLSelectElement>) => props.setTemplateId(parseInt(e.currentTarget.value, 10))}
            />
        );
    };

    return (
        <div key={props.key || '0'} style={{ marginTop: '1.5rem', border: '1px solid grey', boxShadow: '5px 5px 3px #aaaaaa', padding: '2rem' }}>
            <div>{props.customDoc.name}</div>
            <div
                style={{
                    marginLeft: '1rem',
                    marginTop: '1rem',
                    display: 'flex',
                    rowGap: '1rem',
                    alignItems: 'center',
                    flexDirection: 'column',
                }}
            >
                {props.customDoc && (displayTemplateList())}
                <Button
                    text="Generate"
                    className={`dlc-form-button-default medium primary`}
                    onClick={() => props.renderDocTemplate()}
                    size="medium"
                    disabled={props.disabled}
                />
            </div>
        </div>
    );
};

export default DocGenerationComponent;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/DocGenerationComponent.tsx